import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

const couponButtonMobile = media.phone`
  flex: 1;
`;

export const ApplyCouponWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
  input {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: 0 none;
    margin-bottom: 0;
  }
  button {
    font-size: 14px;
    ${couponButtonMobile};
  }
`;
